import { UserModel } from "../../user/_models/user.model";

export class FunctionaryModel {
  id: number;
  name: number;
  last_name: string;
  identification_number: string;
  phone: string;
  mobile: string;
  address: string;
  institutional_email: string;
  personal_email: string;
  birth_date: string;
  profession: string;
  active: string;
  user: any;
}
